import financeDataApi1Raw from '!../bundle-loader!./external/financedata-api/v1.yaml'
import insightsApi1Raw from '!../bundle-loader!./external/insights-api/v1.yaml'
import notificationApi1Raw from '!../bundle-loader!./external/notification-api/v1.yaml'
import partnerApi2Raw from '!../bundle-loader!./external/partner-api/v2.yaml'
import userDetailsApi1Raw from '!../bundle-loader!./external/user-details-api/v1.yaml'
import type { OpenAPIV3_1 as OpenApi3 } from 'openapi-types'

import { deepFreeze } from '@subaio/utils'

export const insightsApi1 = deepFreeze(insightsApi1Raw) as OpenApi3.Document
export const notificationApi1 = deepFreeze(notificationApi1Raw) as OpenApi3.Document
export const partnerApi2 = deepFreeze(partnerApi2Raw) as OpenApi3.Document
export const financeDataApi1 = deepFreeze(financeDataApi1Raw) as OpenApi3.Document
export const userDetailsApi1 = deepFreeze(userDetailsApi1Raw) as OpenApi3.Document
